var map = {
	"./en.json": [
		1202,
		95
	],
	"./fr.json": [
		1203,
		96
	],
	"./widgets/en.json": [
		892,
		8
	],
	"./widgets/fr.json": [
		893,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 788;
module.exports = webpackAsyncContext;